import { EvacuatePathApi } from '@wiz-api/emergency-management'
import {
  map,
  forEach,
  get,
  find,
  concat,
  fromPairs,
  isEmpty,
  findIndex,
  filter,
  reduce,
} from 'lodash'

const evacuatePathApi = new EvacuatePathApi()
// 生成UUID
const getUUID = () => {
  const tempUrl = URL.createObjectURL(new Blob())
  const uuid = tempUrl.toString()
  URL.revokeObjectURL(tempUrl)
  return uuid.substring(uuid.lastIndexOf('/') + 1)
}
/** ************************************************ 路线列表 **************************************** */
// 路线绘制实例列表
let routesInstance = []
// 路线列表
let routeList = []
// 图标列表
const routeIconList = []

let cloudRender

// 初始化数据
const initRouteData = () => {
  routesInstance = []
  routeList = []
  // 图标列表
  routeIconList.length = []
}

// 获取路线列表
const getRouteList = async (sceneId, areaId) => {
  const [err, res] = await evacuatePathApi.getPoint({
    areaId,
    sceneId,
  })
  if (!err && res) {
    return res
  }
  return []
}

// 绘制路线
const drawRoute = async (player, routeDetail) => {
  if (!player.Native) return
  const point = map(JSON.parse(routeDetail.coordinateJson), (item) => {
    return [item.xIndex, item.yIndex, item.zIndex]
  })
  const style = {
    lineColor: '#14ff00',
    lineWidth: 4,
    isLineStipple: true,
    factor: 10,
  }

  const param = {
    id: getUUID(),
    point,
    style,
  }

  const routeObject = await cloudRender.Route.createRoute(param)
  // 缓存围栏绑定的数据id
  routesInstance.push({ id: routeDetail.id, routeObject })
  // 路线列表
}

// 绘制标签
const drawMarker = async (player, routeDetail) => {
  if (!player.Native) return
  const points = JSON.parse(routeDetail.coordinateJson)
  const index = Math.floor(points.length / 2)
  const posArr = [points[index].xIndex, points[index].yIndex, points[index].zIndex]
  const singleOption = {
    id: `${getUUID()}_route`,
    pos: posArr,
    background: 'buildFloor',
    visible: true,
    nodeOffset: [0, 0],
    text: '疏散路线',
    textColor: '#ffffffff',
    hasTriangle: true,
    markPosType: 4,
  }
  // 文字
  const res = await cloudRender.Marker.createBySingleLine(singleOption)
  if (res.status) {
    const data = map(res.data, (item) => {
      return {
        id: item,
        dataId: routeDetail.id,
        type: 'single',
        code: routeDetail.code,
        pos: posArr,
      }
    })
    routeIconList.push(...data)
  }
}
// 标签事件
const markerClick = (e) => {
  // 左键点击并且有id
  if (e.type === 1 && !isEmpty(e.markerId)) {
    const areaInfo = find(routeIconList, (item) => {
      return item.id === e.markerId
    })
    if (areaInfo) {
      // 移动到视角
      const openEvent = new CustomEvent('openEmergencyDisposalDialog', {
        detail: {
          row: { ...areaInfo, id: areaInfo.dataId },
          type: 'EscapeRoute',
        },
      })
      window.dispatchEvent(openEvent)
    }
  }
}

// 创建路线
const create = async (player, sourceId, propCloudRender, areaId) => {
  if (!player.Native) {
    return
  }
  // 初始化数据
  initRouteData()
  cloudRender = propCloudRender
  window.cloudRender = cloudRender
  // 获取路线列表数据
  routeList = await getRouteList(sourceId, areaId)
  // 生成路线
  for (let i = 0; i < routeList.length; i += 1) {
    const item = routeList[i]
    await drawRoute(player, item)
    await drawMarker(player, item)
  }
  cloudRender.Dispatch.on('Marker', markerClick)
}

// 销毁路线
const destroy = async (player) => {
  if (!player.Native) {
    return
  }
  // 销毁图标
  cloudRender.Marker.destroyMarker(map(routeIconList, 'id'))
  // 销毁路线绘制
  forEach(routesInstance, (route) => {
    cloudRender.Route.destroyRoute(route.routeObject.data)
  })
  // 取消标签的事件监听
  cloudRender.Dispatch.off('Marker', markerClick)
}

// 切换标签路线显示隐藏
const toggleDisplay = async (player, type) => {
  // 设置路线的显隐
  forEach(routesInstance, async (route) => {
    cloudRender.Route.setRouteVisible(route.routeObject?.data, type)
  })
}

// 隐藏路线及其标签
const hidden = async (player) => {
  await toggleDisplay(player, false)
}

// 重新显示路线及其标签
const display = async (player) => {
  await toggleDisplay(player, true)
}

// 更新路线显隐（区域改变）
const update = async (player, sourceId, propCloudRender, areaId) => {
  if (!player.Native) {
    return
  }
  // 获取新的路线列表数据
  getRouteList(sourceId, areaId).then((newRouteList) => {
    const newRouteIds = map(newRouteList, (i) => {
      return i.id
    })
    // 更新路线显隐
    const instanceToUpdate = reduce(
      routesInstance,
      (acc, item) => {
        const action = newRouteIds.includes(item.id) ? 'show' : 'hide'
        acc[action].push(item)
        return acc
      },
      { hide: [], show: [] }
    )
    const iconInstanceToUpdate = reduce(
      routeIconList,
      (acc, item) => {
        const action = newRouteIds.includes(item.dataId) ? 'show' : 'hide'
        acc[action].push(item)
        return acc
      },
      { hide: [], show: [] }
    )
    cloudRender.Marker.updateBySingleLine(
      map(iconInstanceToUpdate.hide, (i) => {
        return {
          id: i.id,
          visible: false,
        }
      })
    )
    cloudRender.Marker.updateBySingleLine(
      map(iconInstanceToUpdate.show, (i) => {
        return {
          id: i.id,
          visible: true,
        }
      })
    )
    forEach(instanceToUpdate.hide, async (route) => {
      // 隐藏
      cloudRender.Route.setRouteVisible(route.routeObject?.data, false)
    })
    forEach(instanceToUpdate.show, async (route) => {
      // 展示
      cloudRender.Route.setRouteVisible(route.routeObject?.data, true)
    })
  })
}

export { routeIconList }
export default { create, destroy, hidden, display, update }
